import { useState } from 'react'
import MachineRow from '../components/MachineRow'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap'
import { useMachinesList } from '../hooks/machines'
import { useAuthUser } from 'use-eazy-auth'
import { useReboot } from '../hooks/reboot'
import { useConfig } from '../hooks/config'

export default function Machines() {
  const [{ data: machines }] = useMachinesList()
  const { user } = useAuthUser()

  const [modalReboot, modalRebootActions] = useModalTrigger()
  const [rebooting, setRebooting] = useState(false)
  const [success, setSuccess] = useState(false)
  const [
    { data: rebootOutput, error },
    { run: performReboot, clean: cleanReboot },
  ] = useReboot()

  const config = useConfig()

  return (
    <div className="container-fluid av-content">
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>IP</th>
              <th>Description</th>
              <th>Score</th>
              <th>Last Update</th>
              <th>Pickup Jobs?</th>
              {config?.google_api_reboot_enabled && user.is_staff && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {machines &&
              machines.map((machine) => (
                <MachineRow
                  machine={machine}
                  key={machine.ip_address}
                  canReboot={config?.google_api_reboot_enabled && user.is_staff}
                  onReboot={() => modalRebootActions.open(machine)}
                />
              ))}
          </tbody>
        </table>
      </div>

      <Modal
        isOpen={modalReboot.isOpen}
        toggle={modalReboot.toggle}
        onClosed={() => {
          modalRebootActions.onClosed()
          cleanReboot()
          setRebooting(false)
          setSuccess(false)
        }}
      >
        <ModalHeader toggle={modalRebootActions.toggle}>
          Reboot machine {modalReboot.value?.ip_address}
        </ModalHeader>
        <ModalBody>
          {!success && modalReboot.value && (
            <div>
              Are you sure to reboot machine {modalReboot.value.ip_address}?
            </div>
          )}
          {error && (
            <Alert className="mt-4" color="danger">
              Failed to reboot machine:
              <br />
              {String(error?.response?.detail ?? '')}
            </Alert>
          )}
          {success && <Alert color="success" className="my-2 w-100">
            Machine rebooted successfully!
          </Alert>}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          
            <>
              <Button
                onClick={() => {
                  modalRebootActions.close()
                }}
                color="secondary"
              >
                {success ? 'Close' : 'Cancel'}
              </Button>
              {!success && <Button
                disabled={rebooting}
                onClick={() => {
                  cleanReboot()
                  setSuccess(false)
                  setRebooting(true)
                  performReboot
                    .onFailure((error) => {
                      setRebooting(false)
                    })
                    .onSuccess(() => {
                      setRebooting(false)
                      setSuccess(true)
                    })
                    .run(modalReboot.value.id)
                }}
                color="success"
              >
                Reboot
              </Button>}
            </>
          
        </ModalFooter>
      </Modal>
    </div>
  )
}
